// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"37ffc30d","513":"b1786e89","703":"e3cc3583"}[chunkId] + ".chunk.js";
};